import React from 'react';
import { Checkbox } from 'react-materialize';
import './ChoosePlan.css';

export default class ChoosePlan extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="row plan">
        <div className="col s12 m12 l12">
          <br />
          <span className='planCheckbox'>
          <Checkbox
            id={this.props.title}
            label=""
            value={this.props.title}
            checked={this.props.checked}
            onChange={() => this.props.onChange(this.props.title)}
          />
          </span>
        </div>

        <div className="col s12 m12 l12 planContent">
          <b className='planTitle ellipsis'>{this.props.title}</b>
          <br />
          <span className='planDescription ellipsis'>{this.props.description}</span>
        </div>
      </div>
    );
  }
}
